import { useTuneStore } from '../state/storeTunePrayer';

export const useGetMetaTune = () => {
	const updateImsak = useTuneStore( ( state ) => state.updateImsak );
	const updateFajr = useTuneStore( ( state ) => state.updateFajr );
	const updateSunrise = useTuneStore( ( state ) => state.updateSunrise );
	const updateDhuhr = useTuneStore( ( state ) => state.updateDhuhr );
	const updateAsr = useTuneStore( ( state ) => state.updateAsr );
	const updateMaghrib = useTuneStore( ( state ) => state.updateMaghrib );
	const updateSunset = useTuneStore( ( state ) => state.updateSunset );
	const updateIsha = useTuneStore( ( state ) => state.updateIsha );
	const updateMidnight = useTuneStore( ( state ) => state.updateMidnight );
	const tuneMetaUpdate = ( meta ) => {
		if ( meta[ 'meta-key' ] === 'Imsak' ) {
			updateImsak( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'Fajr' ) {
			updateFajr( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'Sunrise' ) {
			updateSunrise( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'Dhuhr' ) {
			updateDhuhr( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'Asr' ) {
			updateAsr( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'Sunset' ) {
			updateSunset( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'Maghrib' ) {
			updateMaghrib( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'Isha' ) {
			updateIsha( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'Midnight' ) {
			updateMidnight( JSON.parse( meta.value.toString() ) );
		}
	};
	return { tuneMetaUpdate };
};
